export const featuresTypes = [
    'channels',
    'dataTypes',
    'productTypes',
    'purposeTypes',
];
//# sourceMappingURL=featureTypes.js.map